import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=7205ca9c&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
import style0 from "./Overview.vue?vue&type=style&index=0&id=7205ca9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205ca9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7205ca9c')) {
      api.createRecord('7205ca9c', component.options)
    } else {
      api.reload('7205ca9c', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=7205ca9c&scoped=true", function () {
      api.rerender('7205ca9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inbox/Overview.vue"
export default component.exports